import { Box, Typography } from "@mui/material";
import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function ScoreCardButton({ onClick, buttonTitle, showEndIcon }) {
  return (
    <Box
      sx={{
        background: "#DFEEFF",
        cursor: "pointer",
        borderRadius: "20px",
        paddingY: "4px",
        paddingX: "12px",
        display: "flex",
        gap: 1,
        alignItems: "center",
      }}
      onClick={onClick}
    >
      <Typography
        fontFamily="Inter"
        fontWeight={600}
        color="#007BFF"
        fontSize="12px"
      >
        {buttonTitle ? buttonTitle : "View All"}
      </Typography>
      {showEndIcon && (
        <ArrowForwardIosIcon
          fontSize="small"
          style={{
            color: "#007BFF",
            fontSize: "0.8rem",
            fontWeight: 700,
          }}
        />
      )}
    </Box>
  );
}
